import React, { Component } from "react";
import Previews from "./addImage";
import Editors from "./Editors";

export default class TextWithImage extends Component {
  state = {
    image: "",
    text:
      "<h3><b>Cybercrime is fast-growing area of criminality worldwide.</b><br /><br /></h3>" +
      "<p>Criminals worldwide are exploiting the speed, convenience andanonymity of the internet to carry out a" +
      "diverse range ofcriminal activities that know no borders.</p>",
  };
  componentDidMount() {
    console.log(this.props.element);
  }
  onSaveData = (data) => {
    this.props.onSaveData(data);
  };
  onTextChange = (data) => {
    var currentElementId = this.props.element.id;

    var data = {
      image: this.state.image,
      text: data,
    };
    this.props.onSaveData(data, currentElementId);
  };
  render() {
    return (
      <section className="bg-white fade-in">
        <div class="row m-0">
          <div
            class="col-md-6 text-black bg-white d-flex justify-content-center align-items-center flex-column"
            style={{ backgroundColor: "#d7d7d7" }}
          >
            <div class="p-5">
              {this.props.editMode ? (
                <Editors
                  toolbarHidden={true}
                  text={
                    this.props.element.data.text !== ""
                      ? this.props.element.data.text
                      : "Enter your text here"
                  }
                  onTextChange={this.onTextChange}
                ></Editors>
              ) : (
                <div
                  dangerouslySetInnerHTML={{
                    __html: this.props.element.data.text,
                  }}
                ></div>
              )}
            </div>
          </div>
          <div class="col-md-6 p-0">
            {this.props.editMode ? (
              <Previews></Previews>
            ) : (
              <img
                src="https://unlimitedpassion.co.uk/wp-content/uploads/2016/06/placeholder4.png"
                alt=""
                style={{ width: "100%" }}
              />
            )}
          </div>

          <input
            type="file"
            class="edit-mode"
            id="input-wrap"
            name="image"
            accept="image/*"
            capture
            style={{ display: "none" }}
          />
        </div>
      </section>
    );
  }
}
